document.addEventListener("DOMContentLoaded", function() {
    const backButtons = document.querySelectorAll(".title-icon-btn");

    function updateButtonVisibility() {
        backButtons.forEach((button) => {
            const showOnMobile = button.getAttribute("data-show-mobile") === "true";
            const showOnDesktop = button.getAttribute("data-show-desktop") === "true";

            if (window.innerWidth < 768) {
                button.style.display = showOnMobile ? "flex" : "none";
            } else {
                button.style.display = showOnDesktop ? "flex" : "none";
            }
        });
    }

    updateButtonVisibility();

    window.addEventListener("resize", updateButtonVisibility);

    backButtons.forEach((button) => {
        if (!button.dataset.clickBound) {
            button.addEventListener("click", function () {
                const previousButton = document.querySelector(".sticky-buttons .button--previous");
                if (previousButton) {
                    previousButton.click();
                }
            });

            button.dataset.clickBound = "true";
        }
    });
});
